// extracted by mini-css-extract-plugin
export default {"root":"StandalonePrereq_root__ZHyL9","content":"StandalonePrereq_content__7AqUM","actions":"StandalonePrereq_actions__MM0Os"};